import { UserListCatalog } from "~/lib/catalog/user-list-catalog";
import { Filter } from "~/lib/filter";

export default definePayloadPlugin(() => {
    definePayloadReducer('Filter', (data: Filter) => data instanceof Filter && data.toJSON());
    definePayloadReviver('Filter', (data: any) => {
        const value = new Filter(data.fields);
        value.restore(data.values);
        return value;
    });

    UserListCatalog.registerPayload();
});